import {SIGN_UP_STATE} from "../Actions/signupAction";

export default (state = null, action) => {
    switch (action.type) {
        case SIGN_UP_STATE:
            return action.payload;
        default:
            return state;
    }
}
